{
  "key": "vdcapital.symbo.ls",
  "distDir": "smbls"
}